import React from 'react'

import FacebookPixel from './facebook/pixel'

function Pixel({...props}) {
  return(
     props.name === 'FACEBOOK_PIXEL_1' && <FacebookPixel props={props.props}/>
  )
}

export default Pixel